export default function cjkTransform(input) {
  return input
    .replace(/a/gi, "卂")
    .replace(/b/gi, "乃")
    .replace(/c/gi, "匚")
    .replace(/d/gi, "ᗪ")
    .replace(/e/gi, "乇")
    .replace(/f/gi, "千")
    .replace(/g/gi, "Ꮆ")
    .replace(/h/gi, "卄")
    .replace(/i/gi, "丨")
    .replace(/j/gi, "ﾌ")
    .replace(/k/gi, "Ҝ")
    .replace(/l/gi, "ㄥ")
    .replace(/m/gi, "爪")
    .replace(/n/gi, "几")
    .replace(/o/gi, "ㄖ")
    .replace(/p/gi, "卩")
    .replace(/q/gi, "Ɋ")
    .replace(/r/gi, "尺")
    .replace(/s/gi, "丂")
    .replace(/t/gi, "ㄒ")
    .replace(/u/gi, "ㄩ")
    .replace(/v/gi, "ᐯ")
    .replace(/x/gi, "乂")
    .replace(/w/gi, "山")
    .replace(/y/gi, "ㄚ")
    .replace(/z/gi, "乙")
    .replace(/ /gi, "ㅤ");
}
